import React  from "react";
import { Button,Icon } from "semantic-ui-react";


 const AddBtn=({text,onClick,disabled,isDisabled,iconClass='add circle',size='small', ...rest})=>{
    return(
        <Button disabled={isDisabled || disabled} onClick={onClick}
        basic
        color="blue"
            className="btn-add-item"
        size={size}
        {...rest}
        >
       {iconClass && <span>
           <Icon name={iconClass} />
          </span>} {text}
      </Button>
    )
}
export default AddBtn;

